import { controls } from "../../controls";

const rp203 = {
  label: "A/C Opening Register",
  pageLabel: "A/C Opening Register",
  starting: true,
  url: "rp203",
  pageType: "history",
  form: [],
  filter: [
    ...controls.displayText({ tab: "filter", label: "Region", width: "col-sm-2" }),
    ...controls.Region({ tab: "filter", }),
    ...controls.showData({ tab: "filter", name: "region_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Amount From", width: "col-sm-1" }),
    ...controls.floatOnly({ name: "amount_from", width: "col-sm-1" }),
    ...controls.displayText({ tab: "filter", label: "Amount To", width: "col-sm-1" }),
    ...controls.floatOnly({ name: "amount_to", width: "col-sm-1" }),

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", isReadOnly: true, defaultValue: "assigned_branch", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", }),

    ...controls.displayText({ tab: "filter", label: "Depo Period from to", width: "col-sm-2" }),
    ...controls.numberOnly({ name: "depo_period_from", width: "col-sm-1", }),
    ...controls.DaysMonths({ tab: "filter", defaultValue: "days", width: "col-sm-1", name: "depo_units_from" }),
    ...controls.numberOnly({ name: "depo_period_to", defaultValue: 999, width: "col-sm-1", }),
    ...controls.DaysMonths({ tab: "filter", defaultValue: "months", width: "col-sm-1", name: "depo_units_to" }),

    ...controls.displayText({ tab: 'filter', width: "col-sm-2", label: "Product Group" }),
    ...controls.ProductGroup({ tab: 'filter' }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Maturity Period from to", width: "col-sm-2" }),
    ...controls.numberOnly({ name: "mat_period_from", width: "col-sm-1", }),
    ...controls.DaysMonths({ tab: "filter", defaultValue: "days", width: "col-sm-1", name: "mat_units_from" }),
    ...controls.numberOnly({ name: "mat_period_to", defaultValue: 999, width: "col-sm-1", }),
    ...controls.DaysMonths({ tab: "filter", defaultValue: "months", width: "col-sm-1", name: "mat_units_to" }),

    ...controls.displayText({ tab: "filter", label: "Product Type", width: "col-sm-2" }),
    ...controls.ProductType({
      tab: "filter",
    }),
    ...controls.showData({ tab: "filter", data: "product_type_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Interest Rate from to", width: "col-sm-2" }),
    ...controls.floatOnly({ name: "int_rate_from", width: "col-sm-1", }),
    ...controls.floatOnly({ name: "int_rate_to", width: "col-sm-1", }),

    ...controls.displayText({ tab: "filter", label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", }),
    ...controls.showData({ tab: "filter", data: "product_code_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Transaction Type", width: "col-sm-2" }),
    ...controls.TransactionType({ tab: 'filter' }),


    ...controls.magicDateLabel({ tab: "filter", label: "As On Date", width: "col-sm-2" }),
    ...controls.magicDate({ name: "as_on_date" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8" }),

    ...controls.displayText({ tab: "filter", label: "Customer From", width: "col-sm-2" }),
    ...controls.text({ placeHolder: "Customer No From", name: "customer_number_from" }),
    ...controls.displayText({ tab: "filter", label: "Customer To", width: "col-sm-1" }),
    ...controls.text({ placeHolder: "Customer No To", name: "customer_number_to" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-1" }),

    ...controls.checkBox({ tab: "filter", label: "With Address", name: "isPrintAddress", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "filter", label: "With Closed Accounts", name: "isCloseAcc", width: "col-sm-2" }),



    ...controls.displayText({ tab: "filter", label: "Ac No From", width: "col-sm-2" }),
    ...controls.text({ placeHolder: "Ac No From", name: "account_number_from" }),
    ...controls.displayText({ tab: "filter", label: "Ac No To", width: "col-sm-1" }),
    ...controls.text({ placeHolder: "Ac No To", name: "account_number_to" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-1" }),

    ...controls.checkBox({ tab: "filter", label: "With As on FD", name: "isAsOnFD", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "filter", label: "Only New Accounts", name: "isOnlyNewAc", width: "col-sm-2" }),

    ...controls.magicDateLabel({ tab: "filter", label: "Ac Opening From", width: "col-sm-2" }),
    ...controls.magicDate({ name: "ac_open_date_from" }),
    ...controls.magicDateLabel({ tab: "filter", label: "To Date", width: "col-sm-1" }),
    ...controls.magicDate({ name: "ac_open_date_to" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-3" }),
    ...controls.checkBox({ tab: "filter", label: "With Entry By", name: "isPrintEntryBy", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Account Type", width: "col-sm-2 " }),
    ...controls.AccountType({ tab: "filter", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "account_type_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "Occupation", width: "col-sm-4", tag: "basic" }),
    ...controls.Occupation({ tab: "Modal", width: "col-sm-4", tag: "basic" }),
    ...controls.showData({ tab: "Modal", data: "occupation_display", name: "occupation_display", width: "col-sm-4", tag: "basic" }),

    ...controls.displayText({ tab: "Modal", label: "Occupation", width: "col-sm-4", tag: "advanced" }),
    ...controls.Occupation({ tab: "Modal", width: "col-sm-4", tag: "advanced" }),
    ...controls.showData({ tab: "Modal", data: "occupation_display", name: "occupation_display", width: "col-sm-4", tag: "advanced" }),


    ...controls.displayText({ tab: "filter", label: "Number Of Records", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "per_page", placeHolder: "Enter Number Of Records", width: "col-sm-2" }),

    ...controls.HavingSign({ tab: "filter", }),
    ...controls.HavingPhoto({ tab: "filter", }),


  ],

  history: {
    perPage: 10,
    reportHeader: "Deposit Accounts",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "Branch",
        accessor: "branch_code",
        width: 150
      },
      {
        Header: "A/C No",
        accessor: "account_number",
        width: 150
      },
      {
        Header: "CIN",
        accessor: "cin",
      },
      {
        Header: "Name",
        accessor: "description"
      },
      {
        Header: "Opening Balance",
        accessor: "opening_balance",
        type: "currency",
      },

      {
        Header: "Transfer Receipts",
        accessor: "transfer_receipts",
        type: "currency",
      },
      {
        Header: "Cash Receipts",
        accessor: "cash_receipts",
        type: "currency",
      },
      {
        Header: "Clearing Receipts",
        accessor: "clearing_receipts",
        type: "currency",
      },
      {
        Header: "Total Receipts",
        accessor: "total_receipts",
        type: "currency",
        formula: [{ f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'fixed', field: 'transfer_receipts' }, { source: 'fixed', field: 'cash_receipts' }, { source: 'fixed', field: 'clearing_receipts' }], resultVar: 'total' }],
      },
      {
        Header: "Transfer Payments",
        accessor: "transfer_receipts",
        type: "currency",
      },
      {
        Header: "Cash Payments",
        accessor: "cash_receipts",
        type: "currency",
      },
      {
        Header: "Clearing Payments",
        accessor: "clearing_receipts",
        type: "currency",
      },
      {
        Header: "Total Payments",
        accessor: "total_receipts",
        type: "currency",
        formula: [{ f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'fixed', field: 'transfer_receipts' }, { source: 'fixed', field: 'cash_receipts' }, { source: 'fixed', field: 'clearing_receipts' }], resultVar: 'total' }],
      },

      {
        Header: "Date",
        accessor: "trndate",
      },

      {
        Header: "Risk Cat",
        accessor: "risk_cat",
      },
      {
        Header: "PAN",
        accessor: "pan",
      },
      {
        Header: "AADHAAR",
        accessor: "aadhaar",
      },
      {
        Header: "KYC",
        accessor: "kyc",
        type: 'tick'
      },
      {
        Header: "DOB",
        accessor: "dob",
      },
      {
        Header: "Acct Type",
        accessor: "account_type",
      },
      {
        Header: "Mobile",
        accessor: "mobile",
      },
      {
        Header: "Address",
        accessor: "address1",
      },
      {
        Header: "Member Type",
        accessor: "member_type",
      },
      {
        Header: "Interest Type",
        accessor: "interest_type",
      },
    ]
  }

}

export default rp203;